<div class="side-drawer" *ngIf="isSideDrawerVisible" [style.width]="width" pplFocusTrap (escape)="closeAlert()">
    <div class="overlay"></div>
    <div class="content" role="dialog" aria-modal="true" aria-labelledby="drawerTitle">
        <div class="header">
            <div style="display: flex; gap: 8px; align-items: center;">
                <div class="icon">
                    <i class="fa fa-bolt"></i>
                </div>
                <div class="title" id="drawerTitle" tabindex="0">
                    {{ title }}
                </div>
            </div>
            <div class="action">
                <ppl-button
                label=""
                ariaLabel="close"
                icon="fa fa-close" 
                [customClass]="'rounded'" 
                [iconPosition]="'left'"
                (click)="closeAlert()">
                ></ppl-button>
            </div>                   
        </div>            
        <div class="body">
            <div class="body-content" [attr.aria-hidden]="true">
                {{ message }}
                <ng-content></ng-content>
            </div>
        </div>
  </div>
  